import MailingAddress from "./mailing-address";

export default MailingAddress;

export {
    MailingAddress
}